import { countUniqueClients } from './lib/presence-members.mjs';

jQuery(function($) {
    let ably = window.ably
    function setWaitingCount(count, productId) {
        let $wrapper = $(`.wtoy-loop-lottery-thumbnail[data-product-id=${productId}]`)
        $wrapper.find('.wtoy-loop-lottery-thumbnail__waiting-sign').remove();
        if(count > 1) {
            $wrapper.find(`.wtoy-loop-lottery-thumbnail__link`)
                .before(
                    $(`<div class="wtoy-loop-lottery-thumbnail__waiting-sign">
                            <img src="${WTOY_PRODUCT_LIST.lineup_pic_url}" alt="">
                    </div>`)
                )
        }

    }
    $('.wtoy-loop-lottery-thumbnail[data-product-id]').each(function() {
        let $this = $(this);
        let productId = $this.data('product-id');
        if(!productId) {
            return true;
        }
        let channel = ably.channels.get(`product:${productId}`)
        channel.presence.subscribe('enter', (presenceMessage) => {
            channel.presence.get().then(clients => {
                setWaitingCount(countUniqueClients(clients), productId)
            })
        });

        channel.presence.subscribe('leave', (presenceMessage) => {
            channel.presence.get().then(clients => {
                setWaitingCount(countUniqueClients(clients), productId)
            })
        });
        channel.presence.get().then(clients => {
            setWaitingCount(countUniqueClients(clients), productId)
        })
    })
})
